import { SURVEYS_EDIT } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSurveyList } from './hook';
import { SurveyListProps } from './props';

export const SurveyList = ({ filters }: SurveyListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSurveyList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            autoAdjustHeight
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SURVEYS_EDIT}/${item.row.id}`, '_blank')
            }
        />
    );
};
